import { useEffect } from "react";

const DEFAULTS = {
  title: "True North Maintenance — Albury / Wodonga handyman, repairs & cleaning",
  description: "Reliable maintenance, repairs and cleaning done right the first time. Servicing Albury, Wodonga and surrounds within a 60km radius.",
  url: "https://truenorthmaintenance.com.au/",
  image: "https://truenorthmaintenance.com.au/og-image.jpg",
};

function setMeta(selector, attr, value) {
  if (!value) return;
  let el = document.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    const [, key, raw] = selector.match(/\[(name|property)="([^"]+)"\]/) || [];
    if (key && raw) el.setAttribute(key, raw);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
}

function setLink(rel, href) {
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * usePageMeta — sets document title + Open Graph + Twitter + canonical
 * for a single page. Call once at the top of a page component.
 *
 * Example:
 *   usePageMeta({ title: "Services", description: "Every job around the house", path: "/services" });
 */
export default function usePageMeta({ title, description, path, image } = {}) {
  useEffect(() => {
    const fullTitle = title ? `${title} · True North Maintenance` : DEFAULTS.title;
    const desc = description || DEFAULTS.description;
    const url = path ? `https://truenorthmaintenance.com.au${path.startsWith("/") ? path : "/" + path}` : DEFAULTS.url;
    const img = image || DEFAULTS.image;

    document.title = fullTitle;
    setMeta('meta[name="description"]', "content", desc);
    setMeta('meta[property="og:title"]', "content", fullTitle);
    setMeta('meta[property="og:description"]', "content", desc);
    setMeta('meta[property="og:url"]', "content", url);
    setMeta('meta[property="og:image"]', "content", img);
    setMeta('meta[name="twitter:title"]', "content", fullTitle);
    setMeta('meta[name="twitter:description"]', "content", desc);
    setMeta('meta[name="twitter:image"]', "content", img);
    setLink("canonical", url);
  }, [title, description, path, image]);
}
